import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AlfredClientConfig } from './alfred-client.config';

export function provideAlfredClient(
  config: AlfredClientConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AlfredClientConfig, useValue: config },
  ]);
}
